import { useClient, useNavigation } from "@utilities/hooks";
import { Client } from "@utilities/types";
import { useCallback, useEffect, useMemo, useState } from "react";

export const useController = () => {

    const { goBack } = useNavigation();
    const { 
        clients, createClientSuccess,
        onGetAllClients, setCreateClientSuccess,
        onCreateClient, onDeleteClient, onUpdateClient,
    } = useClient();

    const [searchClient, setSearchClient] = useState<string>('');
    const [isAddClientModalOpen, setIsAddClientModalOpen] = useState<boolean>(false);

    const clientsFiltered = useMemo(() => {
        return clients.filter((client) => {
            const matchesSearch = (client.firstname?.toLowerCase().includes(searchClient.toLowerCase()) || false) ||
                (client.lastname?.toLowerCase().includes(searchClient.toLowerCase()) || false) ||
                (client.email?.toLowerCase().includes(searchClient.toLowerCase()) || false) ||
                (client.phoneNumber?.toLowerCase().includes(searchClient.toLowerCase()) || false);
        
            return matchesSearch;
        })
    }, [clients, searchClient]);

    useEffect(()=> {
        onGetAllClients();
    }, []);

    useEffect(()=> {
        if(createClientSuccess){
            onGetAllClients();
            setCreateClientSuccess(false);
        }
    }, [createClientSuccess]);

    const onToggleAddClientModal = useCallback(()=> {
        setIsAddClientModalOpen((prev) => !prev);
    }, []);

    const handleCreateClient = useCallback(async(clientData: Partial<Client>) => {
        await onCreateClient(clientData);
    }, [onCreateClient]);

    const handleEditClient = useCallback(async(clientId: string, clientData: Client) => {
        await onUpdateClient(clientId, clientData);
    }, [onUpdateClient]);

    return { 
        clientsFiltered, isAddClientModalOpen,
        setSearchClient, goBack, 
        onToggleAddClientModal, handleEditClient,
        handleCreateClient, onDeleteClient,
    }
}
